<template src="./index.html"></template>
<script>
import mixin from "@/mixins/index";
const executeColumns = [
  { title: "Birbaşa icraçı", width: "15%", scopedSlots: { customRender: "fullName" } },
  {
    title: "Əlaqə nömrəsi",
    width: "10%",
    scopedSlots: { customRender: "phoneNumber" },
  },
  {
    title: "İcraya verilmə tarixi",
    width: "10%",
    scopedSlots: { customRender: "taskStart" },
  },
  {
    title: "Son icra tarixi",
    width: "20%",
    scopedSlots: { customRender: "lastDate" },
  },
  { title: "İcra vəziyyəti", width: "25%", scopedSlots: { customRender: "status" } },
];
export default {
  name: "ExecutorTable",
  mixins: [mixin],
  props: ["dataSource"],
  data() {
    return {
      executeColumns,
      pagination: { pageSize: 5 },
      mylocale: { emptyText: "Məlumat yoxdur" },
    };
  },
  computed: {
    checkToShowExecuteDetails() {
      return this.dataSource && this.dataSource.length > 0;
    },
  },
  methods: {},
  created() {
    if (!this.dataSource) return;
    const pagination = { ...this.pagination };
    pagination.total = this.dataSource.length;
    this.pagination = pagination;
  },
};
</script>
<style lang="scss" scoped src="./index.scss"></style>
